exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list[data-v-0105af66]{margin-top:48px}", ""]);

// exports
